import BenchmarkRow from './BenchmarkRow'

/**
 * De benchmarks van de meetstandaard-outputs: participatieladder en
 * arbeidsvaardigheden (groei) of materialen (niveau per huishouden).
 *
 * Een output heeft geen doelgroep, dus geen thema; daarom een eigen tabblad
 * naast de themalijst in plaats van een rij daarin.
 *
 * Vier toestanden uit elkaar: laden, bron uitgevallen, echt leeg, en rijen.
 * 'Geen outputs' is een bewering aan de lezer, en die is onwaar zolang de
 * reads onderweg zijn of een bron niet doorkwam.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * @param {object} props
 * @param {Array<import('../../helpers/intelligence/buildBenchmarkOverview').BenchmarkOverviewRow>} props.rows - Rijen uit buildBenchmarkOverview, al gefilterd op dit tabblad
 * @param {boolean} props.loaded - Zijn de outputbronnen binnen
 * @param {Array<string>} props.failedSources - Bronnen van dit tabblad die niet laadden
 * @param {string} props.emptyText - Wat er staat als alles geladen is en er geen rij is
 * @param {((row: object) => void)|null} [props.onOpen] - Rijen met een detailpagina; zonder dit zijn ze niet klikbaar
 */
const OutputBenchmarkList = ({ rows, loaded, failedSources, emptyText, onOpen = null }) => {
    if (!loaded) return <p className="intelligence-state">Benchmarks laden…</p>

    const beoordeelbaar = rows.filter((row) => row.judgeable)
    const gehaald = beoordeelbaar.filter((row) => row.thresholdMet).length

    return (
        <div className="intelligence-agenda">
            {failedSources.length > 0 && (
                <p className="intelligence-state intelligence-state--error">
                    Niet geladen: {failedSources.join(', ')}. Die rijen ontbreken hieronder.
                </p>
            )}
            {rows.length === 0 && failedSources.length === 0 && (
                <p className="intelligence-state">{emptyText}</p>
            )}
            {beoordeelbaar.length > 0 && (
                <p className="intelligence-agenda__meta">
                    {gehaald} van de {beoordeelbaar.length} {gehaald === 1 ? 'haalt' : 'halen'} de drempel
                </p>
            )}
            {rows.length > 0 && (
                <div className="intelligence-agenda-list">
                    {/* 'output' zegt op dit tabblad niets; de familie en de
                        sector wel. */}
                    {rows.map((row) => (
                        <BenchmarkRow key={row.rowId} row={row} tags={row.tags.filter((tag) => tag !== 'output')} onOpen={onOpen} />
                    ))}
                </div>
            )}
        </div>
    )
}

export default OutputBenchmarkList
